import { PORT_PLACE_LIST, PORT_PLACE_PAGINATION } from "./constant";


export const initStateFeed = {
    portPlaceList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case PORT_PLACE_LIST: {
            return {
                ...state,
                portPlaceList: action.payload,
            };
        }
        case PORT_PLACE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
 